import styled, { css } from 'styled-components';
import { Form } from 'antd';

const FormItem = styled(Form.Item)`
  margin-bottom: 0px;
  .ant-form-item-label {
    padding: 0px;
    > label {
      color: black;
    }
  }
  .ant-input-affix-wrapper {
    height: 100%;
  }
  ${props =>
    props.color &&
    css`
      .ant-form-item-label > label {
        color: ${props.color};
      }
    `}
  ${props =>
    props.margin &&
    css`
      .ant-form-item-label > label {
        margin: ${props.margin};
      }
    `}
  ${props =>
    (props.mb || props.mb === 0) &&
    css`
      margin-bottom: ${props.mb}px;
    `}
    ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

FormItem.defaultProps = {};

/** @component */
export default FormItem;
